(function () {
  'use strict';
  const configElement = document.getElementById('OhGiftConfig');
  if (!configElement || !window.OtelloGiftCart || window.ohGiftController) return;
  const config = JSON.parse(configElement.textContent);
  const api = window.OtelloGiftCart;
  const rules = window.OtelloGiftRules;
  const root = config.root || '/';
  let message = '';
  let cartNotice = '';
  let working = 0;
  let timer;
  let refreshRequested = false;
  let cartMutated = false;
  let refreshingUpcart = false;
  let adding = false;
  let actionQueue = Promise.resolve();
  let checking = false;
  let cartRevision = 0;
  const skipHooks = new WeakSet();
  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  };
  function bindNetworkHook() {
    const previous = window.upcartShouldSkipAddToCart;
    if (typeof previous === 'function' && skipHooks.has(previous)) return;
    const skip = function (url, ...args) {
      if (typeof url === 'string' && new URL(url, location.href).searchParams.get('_oh_gift_update') === '1') return true;
      return typeof previous === 'function' ? previous.call(this, url, ...args) : false;
    };
    skipHooks.add(skip);
    window.upcartShouldSkipAddToCart = skip;
  }
  async function request(path, body) {
    if (body) {
      bindNetworkHook();
      if (path === 'cart/add.js' || body.updates) cartMutated = true;
      path += (path.includes('?') ? '&' : '?') + '_oh_gift_update=1';
    }
    const abort = new AbortController();
    const timeout = setTimeout(() => abort.abort(), 15000);
    try {
      const response = await fetch(root + path, { method: body ? 'POST' : 'GET',
        credentials: 'same-origin', cache: 'no-store', signal: abort.signal,
        headers: { Accept: path.startsWith('cart?view=') ? 'text/html' : 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
        ...(body ? { body: JSON.stringify(body) } : {}) });
      const data = await response.json().catch(() => null);
      if (!response.ok) {
        const error = new Error(data?.description || 'Your basket could not be updated. Please try again.');
        error.status = response.status;
        throw error;
      }
      if (!data) throw new Error('Your basket could not be checked. Please try again.');
      return data;
    } finally { clearTimeout(timeout); }
  }
  const transport = {
    read: () => request('cart?view=free-gift&_=' + Date.now()),
    update: body => request('cart/update.js', body),
    add: items => request('cart/add.js', { items })
  };
  const controller = new api.Controller(transport, () => render());
  window.ohGiftController = controller;

  function pdpData(wrapper) {
    const data = JSON.parse(wrapper.querySelector('[data-gift-product-json]').textContent);
    const form = document.getElementById(wrapper.dataset.giftForm);
    const variant = data.variants.find(variant => String(variant.id) === String(form?.querySelector('[name="id"]')?.value || data.selectedVariant));
    return { form, line: { key: 'pdp:' + variant?.id, productId: String(data.id), variantId: String(variant?.id),
      vendor: data.vendor, tags: data.tags, quantity: 1, title: data.title,
      originalLinePence: variant?.price, compareAtPence: variant?.compare_at_price, discountAllocations: [] } };
  }
  function sourceFor(line) {
    const candidates = controller.cart?.lines.filter(item => !api.promotional(item) && item.variantId === line.variantId) || [];
    const selected = api.choiceFrom(controller.cart || { lines: [] });
    return candidates.find(item => item.key === selected?.parentKey) || (candidates.length === 1 ? candidates[0] : line);
  }
  function announce(text, showInCart = false) {
    message = text;
    cartNotice = showInCart ? text : '';
    render();
  }
  function action(task) {
    working++; render();
    const result = actionQueue.then(() => performAction(task));
    actionQueue = result.catch(() => {});
    return result;
  }
  async function performAction(task) {
    try {
      try { return await task(); }
      finally {
        if (cartMutated) {
          cartMutated = false;
          refreshingUpcart = true;
          try {
            if (typeof window.upcartRefreshCart === 'function') await window.upcartRefreshCart();
            if (location.pathname.replace(/\/$/, '').endsWith('/cart') && typeof window.cartPageUpdate === 'function') {
              await window.cartPageUpdate(await request('cart.js'));
            }
            await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
          }
          finally { refreshingUpcart = false; }
        }
      }
    } catch (error) {
      announce(error instanceof Error && error.name !== 'AbortError' ? error.message : 'Your basket could not be checked. Please try again.', true);
      throw error;
    } finally {
      working--; render();
      if (refreshRequested) { refreshRequested = false; schedule(); }
    }
  }
  function render() {
    bindUpcart();
    const cart = controller.cart;
    const choice = !checking && cart && api.choiceFrom(cart);
    for (const wrapper of document.querySelectorAll('[data-gift-live]')) {
      const { line, form } = pdpData(wrapper);
      const accelerated = form?.querySelector('[data-oh-gift-accelerated], .shopify-payment-button');
      if (accelerated) {
        accelerated.dataset.ohGiftAccelerated = '';
        accelerated.hidden = !cart || checking || controller.pending?.variantId === line.variantId || choice?.variantId === line.variantId;
      }
      const panel = wrapper.querySelector('[data-free-gift]');
      if (!panel) continue;
      const source = sourceFor(line);
      if (!working) window.OtelloGiftUI.render(panel, source, controller.pending?.variantId === line.variantId ? controller.pending : choice, cart?.currency || 'GBP');
      const status = wrapper.querySelector('[role="status"]');
      status.textContent = message;
      status.classList.toggle('oh-gift-status--quiet', !cartNotice);
      for (const input of panel.querySelectorAll('[data-gift-kind]')) input.disabled ||= Boolean(working || controller.busy || checking || !cart);
    }
    renderNotice();
    renderSummary();
  }
  function summaryHosts() {
    return [document.querySelector('[data-cart-wrapper] .yvc-summary') || document.querySelector('[data-cart-wrapper]'),
      (window.upcartDocumentOrShadowRoot || document).querySelector('.upcart-footer')].filter(Boolean);
  }
  function renderNotice() {
    const hosts = summaryHosts();
    for (const host of hosts) {
      let notice = host.querySelector('[data-oh-gift-notice]');
      if (!cartNotice) { notice?.remove(); continue; }
      if (!notice) {
        notice = element('p', '', 'oh-gift-notice');
        notice.dataset.ohGiftNotice = '';
        notice.setAttribute('role', 'status');
        host.prepend(notice);
      }
      notice.textContent = cartNotice;
    }
  }
  function giftIcon(kind) {
    const icon = element('img');
    icon.src = kind === 'card' ? config.cardIcon : config.deliveryIcon;
    icon.alt = '';
    icon.width = 28;
    icon.height = 28;
    return icon;
  }
  function renderSummary() {
    const choice = controller.cart && api.choiceFrom(controller.cart);
    for (const host of summaryHosts()) {
      let summary = host.querySelector('[data-oh-gift-summary]');
      if (!choice || checking) { summary?.remove(); continue; }
      if (!summary) {
        summary = element('section', '', 'oh-gift-summary');
        summary.dataset.ohGiftSummary = '';
        summary.setAttribute('aria-label', config.summaryHeading || 'Your free gift');
        const header = element('div', '', 'oh-gift-summary__header');
        header.append(element('span', '', 'oh-gift-summary__icon'),
          element('h2', config.summaryHeading || 'Your free gift', 'oh-gift-summary__heading'),
          element('span', config.selectedBadge || 'Selected', 'oh-gift-summary__badge'));
        const footer = element('div', '', 'oh-gift-summary__footer');
        const remove = element('button', config.removeLabel || 'Remove', 'oh-gift-summary__remove');
        remove.type = 'button';
        remove.setAttribute('aria-label', config.removeGiftLabel || 'Remove your free gift');
        remove.addEventListener('click', () => {
          action(() => controller.clear()).then(() => announce('Your gift selection was removed.')).catch(() => {});
        });
        footer.append(element('p', config.summaryReview || 'Subject to eligibility review.', 'oh-gift-summary__review'), remove);
        summary.append(header, element('p', '', 'oh-gift-summary__title'),
          element('p', '', 'oh-gift-summary__source'), element('p', '', 'oh-gift-summary__details'), footer);
        host.prepend(summary);
      }
      if (summary.dataset.kind !== choice.kind) {
        summary.querySelector('.oh-gift-summary__icon').replaceChildren(giftIcon(choice.kind));
        summary.dataset.kind = choice.kind;
      }
      const source = controller.cart.lines.find(line => line.key === choice.parentKey);
      const copy = {
        title: choice.kind === 'card' ? (config.cardTitle || '£[amount] e-gift card').replace('[amount]', choice.faceValuePence / 100) : config.deliveryTitle || 'Free White Glove Delivery',
        source: (config.summarySource || 'With [item]').replace('[item]', source.title),
        details: choice.kind === 'card'
          ? config.summaryCardDetails || 'Issued 30 days after your final item is delivered. Valid for 6 months from issue.'
          : config.summaryDeliveryDetails || 'Delivered and assembled in your chosen room. Location and product exclusions may apply.'
      };
      for (const [name, text] of Object.entries(copy)) {
        const node = summary.querySelector('.oh-gift-summary__' + name);
        if (node.textContent !== text) node.textContent = text;
      }
      summary.querySelector('button').disabled = Boolean(working || controller.busy);
      summary.setAttribute('aria-busy', String(Boolean(working || controller.busy)));
    }
  }
  async function refresh() {
    const revision = cartRevision;
    const previous = controller.cart && api.choiceFrom(controller.cart);
    const hadGift = api.hasRequest(controller.cart);
    await controller.refresh();
    if (revision === cartRevision) checking = false;
    const choice = api.choiceFrom(controller.cart);
    if ((hadGift || previous) && !choice) announce(config.removedNotice || 'Your free gift was removed because its qualifying item was removed or no longer meets the offer terms.', true);
    else if (previous?.kind === 'card' && choice?.kind === 'card' && previous.faceValuePence !== choice.faceValuePence) announce('Your gift card amount has been updated to match your qualifying item.', true);
  }
  function schedule() {
    if (refreshingUpcart) return;
    if (working) { refreshRequested = true; return; }
    clearTimeout(timer);
    timer = setTimeout(() => { action(refresh).catch(() => {}); }, 120);
  }
  function cartUpdated() {
    if (!refreshingUpcart) {
      cartRevision++;
      if (api.hasRequest(controller.cart)) { checking = true; render(); }
    }
    schedule();
  }
  for (const wrapper of document.querySelectorAll('[data-gift-live]')) {
    wrapper.addEventListener('change', event => {
      const checkbox = event.target.closest('[data-gift-kind]');
      if (!checkbox) return;
      if (checkbox.checked) for (const other of wrapper.querySelectorAll('[data-gift-kind]')) if (other !== checkbox) other.checked = false;
      const source = sourceFor(pdpData(wrapper).line);
      const key = source.key.startsWith('pdp:') ? null : source.key;
      const kind = checkbox.checked ? checkbox.dataset.giftKind : null;
      action(() => controller.select(kind, key, source)).then(() => announce(kind ? key ? 'Your gift selection was updated.' : 'Your gift will be added with this item.' : 'Your gift selection was removed.')).catch(() => {});
    });
    const { form } = pdpData(wrapper);
    form?.addEventListener('change', () => {
      const line = pdpData(wrapper).line;
      if (controller.pending && controller.pending.variantId !== line.variantId) {
        controller.pending = null; announce('Your gift selection was removed after changing the variant.', true);
      }
      render();
    });
  }
  function wrapperFor(form) {
    return [...document.querySelectorAll('[data-gift-live]')].find(wrapper => wrapper.dataset.giftForm === form?.getAttribute('id') && wrapper.querySelector('[data-free-gift]'));
  }
  async function add(form, wrapper, checkout) {
    const fields = new FormData(form);
    const item = { id: fields.get('id'), quantity: Number(fields.get('quantity') || 1), properties: {} };
    if (fields.get('selling_plan')) item.selling_plan = fields.get('selling_plan');
    for (const [key, value] of fields) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) {
        if (typeof value !== 'string') throw new Error('Please purchase without a promotional gift when uploading a custom file.');
        item.properties[match[1]] = value;
      }
    }
    if (!Number.isSafeInteger(item.quantity) || item.quantity < 1) throw new Error('Please enter a valid quantity.');
    await action(() => controller.addFurniture(item, pdpData(wrapper).line));
    announce('Added to your basket. Any selected reward is pending eligibility review.');
    if (checkout) { await action(refresh); location.assign(root + 'checkout'); }
    else if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
    else location.assign(root + 'cart');
  }
  function startAdd(form, wrapper, checkout) {
    if (adding) return;
    adding = true;
    const buttons = [...document.querySelectorAll('.Sd_addProduct')].filter(button => button.form === form && !button.disabled);
    for (const button of buttons) { button.disabled = true; button.classList.add('is-loading'); }
    add(form, wrapper, checkout).catch(error => announce(error.message, true)).finally(() => {
      adding = false;
      for (const button of buttons) { button.disabled = false; button.classList.remove('is-loading'); }
    });
  }
  document.addEventListener('submit', event => {
    const wrapper = wrapperFor(event.target);
    if (!wrapper) {
      if (event.target.matches?.('form[action$="/cart"]') && event.submitter?.name === 'checkout' && api.hasRequest(controller.cart)) {
        event.preventDefault(); event.stopImmediatePropagation();
        action(refresh).then(() => location.assign(root + 'checkout')).catch(() => {});
      }
      return;
    }
    if (!controller.pending && !working) return;
    event.preventDefault(); event.stopImmediatePropagation();
    startAdd(event.target, wrapper, event.submitter?.value === '/checkout');
  }, true);
  function guardCheckout(event) {
    const path = event.composedPath();
    const addButton = path.find(node => node.matches?.('.Sd_addProduct'));
    const addForm = addButton?.form || (addButton && document.getElementById(addButton.getAttribute('form'))) || addButton?.closest('form');
    const addWrapper = wrapperFor(addForm);
    if (addWrapper && (controller.pending || working || adding)) {
      event.preventDefault(); event.stopImmediatePropagation();
      startAdd(addForm, addWrapper, false);
      return;
    }
    const finance = path.find(node => node.matches?.('[data-finance-cta]'));
    if (finance && wrapperFor(finance.form) && (controller.pending || (api.hasRequest(controller.cart) || controller.cart?.lines.some(api.promotional)))) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!working) add(finance.form, wrapperFor(finance.form), true).catch(error => announce(error.message, true));
      return;
    }
    const checkout = path.find(node => node.matches?.('.upcart-checkout-button, [name="checkout"], a[href*="/checkout"]'));
    if (!checkout || (controller.cart && !api.hasRequest(controller.cart) && !controller.cart.lines.some(api.promotional) && !working)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (!working) action(refresh).then(() => location.assign(root + 'checkout')).catch(() => {});
  }
  document.addEventListener('click', guardCheckout, true);
  const bound = new Set();
  const guardedRoots = new WeakSet();
  function syncUpcartStyles() {
    const host = window.upcartDocumentOrShadowRoot;
    if (!host?.host) return;
    const pageStyles = [...document.head.querySelectorAll('link[rel="stylesheet"]')]
      .filter(link => new URL(link.href, location.href).pathname.endsWith('/free-gift.css'));
    const href = pageStyles.at(-1)?.href || config.stylesheet;
    if (!href) return;
    let stylesheet = host.querySelector('[data-oh-gift-styles]');
    if (!stylesheet) {
      stylesheet = element('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.dataset.ohGiftStyles = '';
      host.prepend(stylesheet);
    }
    const resolved = new URL(href, location.href).href;
    if (stylesheet.href !== resolved) stylesheet.href = resolved;
  }
  function bindUpcart() {
    bindNetworkHook();
    const host = window.upcartDocumentOrShadowRoot;
    syncUpcartStyles();
    if (host && host !== document && !guardedRoots.has(host)) {
      host.addEventListener('click', guardCheckout, true);
      guardedRoots.add(host);
    }
    for (const name of ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeItemRemoved', 'upcartSubscribeAddedToCart', 'upcartSubscribeCartOpened']) {
      if (!bound.has(name) && typeof window[name] === 'function') {
        window[name](['upcartSubscribeCartUpdated', 'upcartSubscribeItemRemoved'].includes(name) ? cartUpdated : schedule);
        bound.add(name);
      }
    }
  }
  const styleObserver = new MutationObserver(syncUpcartStyles);
  styleObserver.observe(document.head, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  bindUpcart();
  const binding = setInterval(() => { bindUpcart(); if (bound.size === 5) clearInterval(binding); }, 500);
  setTimeout(() => clearInterval(binding), 30000);
  window.addEventListener('pageshow', event => { if (event.persisted) schedule(); });
  document.addEventListener('oh:cart-page-updated', cartUpdated);
  window.addEventListener('focus', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  action(refresh).catch(() => {});
})();
